/** Paths that must not trigger a forced redirect to /login on 401 (registration, sign-in, verify). */
export function isPublicAppPath(pathname) {
  const p = (pathname || '').split('?')[0];
  if (!p) return false;
  if (p === '/login' || p === '/pricing' || p === '/payment') return true;
  if (p === '/register' || p.startsWith('/register/')) return true;
  if (p.startsWith('/login/')) return true;
  if (p.startsWith('/forgot-password') || p.startsWith('/reset-password')) return true;
  if (p.startsWith('/verify-email')) return true;
  if (p.startsWith('/verify/') || p.startsWith('/01/')) return true;
  if (p === '/product-register' || p === '/warranty-claim') return true;
  if (p.startsWith('/super-user/login')) return true;
  if (p.startsWith('/super-user/dashboard')) return true;
  if (p.startsWith('/login/mobile-registration')) return true;
  return false;
}
